module.exports = __webpack_public_path__ + "f8d3277d21cac5f44d693e405c6448a2.pdf";